module.exports = __webpack_public_path__ + "img/0.a383ea67.jpg";